const fIntNumberFormatter = new Intl.NumberFormat('it-IT', {
  style: 'decimal',
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
  useGrouping: true,
});

export function fIntNumber(n: number) {
  return fIntNumberFormatter.format(n);
}

export const formatAmountNoDecimals = (n: number, currency: string) => {
  return new Intl.NumberFormat('it-IT', {
    style: 'currency',
    currency,
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
    useGrouping: true,
  }).format(n);
};

export const formatAmountWithDecimals = (n: number) => {
  return new Intl.NumberFormat('it-IT', {
    style: 'decimal',
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
    useGrouping: true,
  }).format(n);
};

export const formatEurAmountNoDecimals = (n: number) => {
  return formatAmountNoDecimals(n, 'EUR');
};

export const formatStringAmount = (amount: string, currency: string): string => {
  return new Intl.NumberFormat('it-IT', {
    style: 'currency',
    currency,
  }).format(parseFloat(amount));
};

const vatFormatter = Intl.NumberFormat('it-IT', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
  useGrouping: false,
});

export const formatFloat = (n: number) => {
  return vatFormatter.format(n);
};

const decimalNumberFormatter = Intl.NumberFormat('it-IT', {
  minimumFractionDigits: 2,
  useGrouping: true,
});

export const fDecimalNumberTwoDecimal = (n: number) => {
  return decimalNumberFormatter.format(n);
};

export const percentageFormatterNoDigits = new Intl.NumberFormat('it-IT', {
  style: 'percent',
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
});

const percentageFormatterOneDigits = new Intl.NumberFormat('it-IT', {
  style: 'percent',
  maximumFractionDigits: 1,
  minimumFractionDigits: 0,
});

export const formatPercentageLimitingDecimals = (percentage: number) => {
  const formatter = percentage < 10 ? percentageFormatterOneDigits : percentageFormatterNoDigits;
  return formatter.format(percentage / 100);
};

const percentageFormatterTwoDigits = new Intl.NumberFormat('it-IT', {
  style: 'percent',
  maximumFractionDigits: 2,
});

export const formatPercentageTwoDigits = (percentage: number) => {
  return percentageFormatterTwoDigits.format(percentage / 100);
};
